import { periodKind, taskStatus, dataFixStatus } from '../../../../_constants/Code'

/**
 * 指定年度のデータが確定状態かを非同期に判定する。
 *
 * @param {number} year - 対象年度（西暦4桁）
 * @param {string} accPeriod - 決算月（例："12月"）
 * @param {Array} dataCreateTask - データ作成タスクの配列
 * @returns {Promise<boolean>} 確定済みならtrue、それ以外はfalse
 */
export const checkConfirmedStatus = async (year, accPeriod, dataCreateTask) => {
  const accPeriodMatch = accPeriod.match(/^(\d{1,2})月$/)
  if (!accPeriodMatch) throw new Error('決算月のフォーマット不正')
  const _accPeriod = Number(accPeriodMatch[1])

  try {
    // 各種期間種別で確定状態を判定
    const isPeriodConfirmed = (year) => {
      return dataCreateTask.some((task) => {
        const isPeriod = task.PeriodKind === periodKind.year.value
        const isStatusValid = [taskStatus.doing.value, taskStatus.done.value].includes(task.TaskStatus)
        const taskYearMatch = task.PeriodValue && task.PeriodValue.match(/^(\d{4})年/)
        const taskYear = Number(taskYearMatch ? taskYearMatch[1] : null)
        const _taskYear = _accPeriod === 12 ? taskYear : taskYear - 1
        const isYearMatch = _taskYear === year
        const isConfirmed = task.DataFixStatus === dataFixStatus.fix.value
        return isPeriod && isStatusValid && isYearMatch && isConfirmed
      })
    }

    // 年次が確定しているか判定
    const yearlyConfirmed = isPeriodConfirmed(year)
    return yearlyConfirmed
  } catch (error) {
    console.error('確認状態の取得に失敗しました。', error)
    return false
  }
}

/**
 * 現在の年度を判定し年度文字列を返す関数。
 *
 * @param {object} props - Propsオブジェクト（accPeriodを含む）
 * @returns {string} 年度文字列（例："2023年度"）
 */
export const calculateCurrentYear = (props) => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  return `${props.accPeriod !== '12月' && month <= parseInt(props.accPeriod.slice(0, -1), 10) ? year - 1 : year}年度`
}
